import {
  getCommissioningPipelineStatusesConfig,
  getCommissioningStatusValuesList,
} from '../../helpers/commissioningStatuses';
import i18n from '../../plugins/i18n';

const configurations = {
  statusValuesList: getCommissioningStatusValuesList(true),
  electricityTypeValuesList: [
    {
      label: i18n.t('commissioning.electricity_type_filters.all'),
      value: 'all',
      color: '#999999',
    },
    {
      label: i18n.t('commissioning.electricity_type_filters.feedin'),
      value: 'true',
      color: '#d79bb8',
    },
    {
      label: i18n.t('commissioning.electricity_type_filters.consumption'),
      value: 'false',
      color: '#9B0040',
    },
  ],
  headersAktive: [
    { text: 'Datum', value: 'date' },
    { text: 'Antragsteller', value: 'applicant' },
    { text: 'Produktgruppe', value: 'product' },
    { text: 'Anschlussadresse', value: 'address' },
    { text: 'zul. bearbeitet von', value: 'lastChangedBy' },
    {
      text: 'Journey',
      value: 'journey',
      class: 'hide-column',
      align: ' d-none',
      filterable: true,
      filter: (value) =>
        this.filterJourney ? value === this.filterJourney : true,
    },
    {
      text: 'Status',
      value: 'status',
      filterable: true,
      filter: (value) =>
        this.statusSelection === 'all' || value === this.statusSelection,
    },
    { value: 'edit' },
  ],
  countOrderStatuses: getCommissioningPipelineStatusesConfig(),
};

export const getCommissioningTableConfig = (configName) => {
  return JSON.parse(JSON.stringify(configurations[configName]));
};
